<template>
  <div class="passoTransporte">
    <div>
      <div class="passoTransporte_header">
        <h3 class="passoTransporte_header_title">
          Transporte de Registro
        </h3>
      </div>
      <div class="row px-2 pt-2 mb-4">
        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Livro</label>
          <input v-model="localData.livro"
                 v-validate="'required'"
                 type="number"
                 name="transporte_livro"
                 :class="{'is-invalid' : errors.has('transporte_livro')}"
                 class="form-control form-control-sm"
                 @change="changeData()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Folha</label>
          <input v-model="localData.folha"
                 v-validate="'required'"
                 type="number"
                 name="transporte_folha"
                 :class="{'is-invalid' : errors.has('transporte_folha')}"
                 class="form-control form-control-sm"
                 @change="changeData()">
        </div>

        <div class="col-2">
          <label
            class="label"
            for="falecido_digitador_nome">Lado</label>
          <select v-model="localData.lado"
                  v-validate="'required'"
                  name="transporte_lado"
                  :class="{'is-invalid' : errors.has('transporte_lado')}"
                  class="form-control form-control-sm"
                  @change="changeData()">
            <option>FRENTE</option>
            <option>VERSO</option>
          </select>
        </div>
        <div class="col-2">
          <label
            class="label"
            for="data_transporte">Data do Transporte</label>
          <input v-model="localData.data_transporte"
                 name="data_transporte"
                 type="date"
                 :class="{ 'is-invalid': errors.has('data_transporte') }"
                 class="form-control form-control-sm"
                 @change="changeData()">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* libraries */
  import { mapGetters } from 'vuex'
  import moment  from "moment"

  export default {
    name: 'AbaTransporte',
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      propCartorio: {
        type: Object,
        default: () => ({})
      }
    },
    inject: ['$validator'],
    data () {
      return {
        localData: {
          data_transporte: null,
          termo: '',
          livro: '',
          folha: '',
          lado: '',
        },
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        lados: [{title: "Frente", key: "FRENTE"}, {title: "Verso", key: "VERSO"}],
        data_inicial: moment('1500/01/01').format("YYYY-MM-DD"),
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      data (newObj, oldObj) {
        if (Object.entries(newObj).length) this.setData(newObj)
      }
    },
    async created () {
      if (!!this.data.registro.transporte) {
        this.localData = this.data.registro.transporte
      }
    },
    methods: {
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      setData (val) {

        this.localData.data_transporte = val.registro && val.registro.transporte.data_transporte

        Object.assign(this.localData, {
          livro: this.data.registro && this.data.registro.transporte.livro,
          folha: this.data.registro && this.data.registro.transporte.folha,
          termo: this.data.registro && this.data.registro.transporte.termo,
          lado: this.data.registro && this.data.registro.transporte.lado
        })

      },
      changeData () {
        let obj = { ...this.data }

        obj.registro.transporte.data_transporte = this.localData.data_transporte

        obj.registro.transporte.livro = this.localData.livro
        obj.registro.transporte.folha = this.localData.folha
        obj.registro.transporte.termo = this.localData.termo
        obj.registro.transporte.lado = this.localData.lado

        this.$validator.validateAll().then((resp) => {
          if (resp) { 
            switch (this.data.registro.tipo_registro) {
            case 'N':
              this.$emit('updateInfo', obj) 
              break

            case 'O': case 'NT':
              this.$emit('changed', obj) 
              break
              
            case 'C': case 'CR':
              this.$emit('change', obj) 
              break
            }
          }
        })
      },
      validateInputs (name) {
        this.$validator.validate(name)
        this.changeData()
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .passoTransporte {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }
</style>
